/** @module csi/widget/RadioButtonGroup */
define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/form/RadioButton",
	"underscore",
	"csi/html"

], function(declare,_TemplatedMixin,_WidgetBase,RadioButton,_,html){

	return  declare([_WidgetBase,_TemplatedMixin], {
		templateString: '<div class="${baseClass}-container" data-dojo-attach-point="containerNode">' +
			'<div class="${baseClass}-header">${header}</div>' +
			'<div class="${baseClass}-items" data-dojo-attach-point="listNode"></div>' +
		'</div>',

		baseClass: "csi-radio-button-group",

		/** @property {string} header - heading of the radio button group */
		header: "",

		/** @property {Object[]} items - list of radio button */
		items: null,

		/** @property {string} name - name for the radio button */
		name: "",

		/**
		 * @override
		 * Render the properties to the list box
		 */
		postCreate: function() {
			this.inherited(arguments);
			_.each(this.items, this._addRadioButtonBox, this);

		},

		/**
		 * Create html element and add to list
		 * @param {Object} item
		*/
		_addRadioButtonBox: function(item) {
			var div = html.create("div", {"class": this.baseClass + "-item", }, this.listNode);
			$(div).data("highlightClass", item.highlightClass);
			var radio = new RadioButton({
				name: this.name,
				value: item.value
			}).placeAt(div);
			var labelBox = html.create("div", {"class": this.baseClass + "-label-box"}, div);
			html.create("label", {
				"class": this.baseClass + "-item-label-bold csi-bold-key-label",
				innerText: item.keyText,
				for: radio.get("id")
			}, labelBox);
			html.create("label", {
				"class": this.baseClass + "-item-label csi-bold-key-label-value",
				innerText: item.label,
				for: radio.get("id")
			}, labelBox);
		}

	});
});